module.exports = __webpack_public_path__ + "static/Corona-Banner-MB-Landing.6315f9ad.jpg";